import { ServiceStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class AssetByCode {
    @ApiProperty()
    assetsCode: string;
    @ApiProperty()
    assetServiceId: number;
    @ApiProperty()
    status?: ServiceStatusEnum
    @ApiProperty()
    remarks?: string;
    @ApiProperty()
    assetId?: any;
    @ApiProperty()
    plant?: any;
}